var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card card-container"},[(!this.message)?_c('div',[_c('label',{staticClass:"body-text-m"},[_vm._v("Teid logitakse praegu sisse")])]):_vm._e(),(!!this.message)?_c('div',[_c('label',{staticClass:"body-text-m"},[_vm._v(_vm._s(this.message))]),_c('label')]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }